import { useState } from 'react';
/**Components */
import HeaderPage from '../../components/page/header';
import BodyPage from '../../components/page/body';
import ModalComponent from '../../components/modal';
/** Componentes propios */
import Filter from './filter';
import FormClient from './form';
/**Hooks */
import { useClients } from '../../hooks';
/**Models */
import { ClientRequest } from '../../models/requests';
/**Utilities */
import { SweetAlert } from '../../utilities';

/** Modal Resource */
interface DataModalState {
  type: string;
  buttonSubmit: string | null;
  row: any | null;
  title: string | null;
  requirements: any[];
  onCloseModalForm: () => void;
  errosBackend: any;
}

export const ClientIndex = () => {
  const { fetchClients, storeClient, updateClient, personSearch } = useClients();
  const [dataModalResourceState, setDataModalResourceState] = useState<DataModalState>({
    type: '',
    buttonSubmit: null,
    row: null,
    title: null,
    requirements: [],
    onCloseModalForm: () => {},
    errosBackend: {},
  });
  const [errors, setErrors] = useState({});
  const [filterState, setFilterState] = useState({
    page: 1,
    type: '',
    text: '',
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [stateModal, setStateModal] = useState<boolean>(false);

  //let errorsBakend = {};
  const state = {
    page: {
      title: 'Clientes',
      icon: 'ri-user-star-line',
      model: 'clients',
      header: {
        menu: ['Clientes'],
      },
      buttons: {
        create: true,
        edit: true,
        destroy: false,
        import: false,
        export: false,
      },
    },
    dataTable: {
      body: {
        cols: [
          {
            name: 'client_document_type_name',
            alias: 'Tipo de documento',
            width: '12%',
          },
          {
            name: 'document_number',
            alias: 'N° documento',
            width: '10%',
          },
          {
            name: 'names',
            alias: 'Cliente',
          },
          {
            name: 'type_client',
            alias: 'Tipo de cliente',
            width: '10%',
          },
          {
            name: 'state',
            alias: 'Estado',
            width: '7%',
            play: {
              type: 'states',
              values: {
                0: 'bg-danger-subtle text-danger',
                1: 'bg-success-subtle text-success',
              },
              names: {
                0: 'Inactivo',
                1: 'Activo',
              },
            },
          },
        ],
      },
    },
  };

  /** METODOS DEL FILTER */
  const onChangePage = (page: number, type: string) => {
    switch (type) {
      case 'prev':
        setFilterState({ ...filterState, page: filterState.page - 1 });
        fetchClients(filterState.page - 1, filterState.text, filterState.type, true);
        break;

      case 'current':
        setFilterState({ ...filterState, page: page });
        fetchClients(page, filterState.text, filterState.type, true);
        break;
      case 'next':
        setFilterState({ ...filterState, page: filterState.page + 1 });
        fetchClients(filterState.page + 1, filterState.text, filterState.type, true);
        break;
      default:
        break;
    }
  };
  const onClearFilters = () => {
    setFilterState({ ...filterState, text: '', type: '' });
    fetchClients(1, '', '', true);
  };

  const handleFilterChange = (newFilters: any) => {
    setFilterState(newFilters);
    fetchClients(1, newFilters.text, newFilters.type, false);
  };

  /** METODOS DE MODAL */
  const onCloseModalForm = () => {
    setStateModal(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setErrors({});
  };

  const onClickAddResource = (type: string) => {
    setDataModalResourceState({
      type: type,
      buttonSubmit: 'Registrar',
      row: null,
      title: 'Nuevo cliente',
      requirements: [],
      onCloseModalForm: onCloseModalForm,
      errosBackend: {},
    });
    setStateModal(true);
    setIsModalOpen(true);
  };

  const onClickDeleteResource = () => {};

  const onClickEditResource = (row: any) => {
    setDataModalResourceState({
      type: 'edit',
      buttonSubmit: 'Editar',
      row: {
        id: row.id,
        person: row
      },
      title: 'Editar cliente',
      requirements: [],
      onCloseModalForm: onCloseModalForm,
      errosBackend: {},
    });
    setStateModal(true);
    setIsModalOpen(true);
  };

  /** METODOS DEL FORM RESOURCE */
  const onSubmitForm = async (clientRequest: ClientRequest, type: string) => {
    switch (type) {
      case 'store':
        storeClient(clientRequest)
          .then(() => {
            onCloseModalForm();
            SweetAlert.success('Mensaje', 'Cliente registrado correctamente.');
          })
          .catch((error) => {
            setErrors(error.response.data.errors);
          });
        break;
      case 'edit':
        updateClient(clientRequest)
          .then(() => {
            onCloseModalForm();
            SweetAlert.success('Mensaje', 'Cliente actualizada correctamente.');
          })
          .catch((error) => {
            setErrors(error.response?.data.errors);
          });
        break;
      default:
        break;
    }
  };

  const onClickButtonPersonalizado = () => {};

  return (
    <div className="main-body p-0">
      <div className="inner-wrapper">
        <div className="inner-main">
          <HeaderPage page={state.page} onModalResource={onClickAddResource} />
          <div className="inner-main-body">
            <div className="card card-featured card-featured-primary mb-3 mt-3">
              <div className="card-body">
                <Filter
                  onClearFilters={onClearFilters}
                  filterState={filterState}
                  onFilterChange={handleFilterChange}
                />
                <BodyPage onChangeDelete={onClickDeleteResource} onClickButtonPersonalizado={onClickButtonPersonalizado} onChangeEdit={onClickEditResource} onChangePage={onChangePage} page={state.page} table={state.dataTable} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Resource */}
      {isModalOpen && (
        <ModalComponent
          stateModal={stateModal}
          typeModal={'static'}
          size={'modal-gg'}
          title={dataModalResourceState.title}
          content={<FormClient onSearchPerson={personSearch} errors={errors} data={dataModalResourceState} onSubmitForm={onSubmitForm} />}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default ClientIndex;
